import { WebStorageStateStore } from "oidc-client-ts";

export const oidcConfig = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}`,
  client_id: `mca`,
  redirect_uri: `${window.location.origin}/dashboard`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  post_logout_redirect_uri: window.location.origin,
  scope: "openid profile matricula orgaos orgaoExterno cargo mca-roles foto",
  metadata: {
    issuer: `${process.env.REACT_APP_KEYCLOAK_URL}`,
    authorization_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/auth`,
    token_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/token`,
    introspection_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/token/introspect`,
    userinfo_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/logout`,
    jwks_uri: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/certs`,
    check_session_iframe: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/login-status-iframe.html`,
    registration_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/clients-registrations/openid-connect`,
    revocation_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/protocol/openid-connect/revoke`,
  },
};
